import { useMutation } from "@tanstack/react-query";
import { axiosInvoiceLess } from "../libs/axios";

interface IItem{
  name: string;
  quantity: number;
  price: number;
}

interface IInvoice{
    customer: string;
    status : 'Draft' | 'Paid' | 'Pending'  | 'Unpaid' | 'Canceled' | 'Partial' | 'Refunded';
    items : Array<IItem>;
}

interface IInvoiceResponse{
  id: string;
  url: string;
}
const normolize = (req: IInvoiceResponse) => {
  return req as IInvoiceResponse
}

const createInvocie = async (params: IInvoice) =>{
  try{
    const res = (await axiosInvoiceLess.post('/invoices', params)).data;
    return normolize(res);
  }catch(error){
    console.log('Error invoice customer');
  }
}

export const useCreateInvoice = () => {
  return useMutation({
    mutationKey: ['create-invoice'],
    mutationFn: createInvocie,
  });
};